import gsap from 'gsap';
import SplitText from '@/assets/lib/gsap/uncompressed/utils/SplitText';

import { revertSplit } from '@/scripts/utils';


const lerp = (a, b, n) => ((1 - n) * a) + (n * b);
const animations = new Map();

animations.set('parallax', (el) => {
  const elH = el.parentElement.clientHeight;

  const offsetTopFromCenter = (el.parentElement.getBoundingClientRect().top -
  ((window.innerHeight - elH) / 2));
  let final = 1;

  const coefficent = el.getAttribute('data-parallax') !== null ? el.getAttribute('data-parallax') : 1;

  const maxY = Math.max(-window.innerHeight, offsetTopFromCenter);
  const baseTransform = Math.floor(Math.min(window.innerHeight, maxY), 2);

  const translateY = baseTransform * coefficent;

  final = lerp(final, translateY, 1);

  // el.style.transform = `translateY(${final}px)`;

  gsap.set(el, { y: final });
});

const offsets = [];
animations.set('parallaxIn', (el, i) => {
  // const elH = el.parentElement.clientHeight;

  // const offsetTopFromCenter = (el.parentElement.getBoundingClientRect().top -
  // ((window.innerHeight - elH) / 2));
  // let final = 1;

  // const coefficent = el.getAttribute('data-parallaxIn') !== null ? el.getAttribute('data-parallaxIn') : 1;

  // const maxY = Math.max(-window.innerHeight, offsetTopFromCenter);
  // const baseTransform = Math.floor(Math.min(window.innerHeight, maxY), 2);

  // const translateY = baseTransform * coefficent;

  // // final = lerp(final, translateY, 1);

  // // el.style.transform = `translateY(${final}px)`;

  // gsap.to(el, 0.3, { y: translateY, ease: gsap.Expo.easeOut });
  const bound = el.parentElement.getBoundingClientRect().top;
  let final = 1;

  if (!el.getAttribute('data-animated')) {
      el.setAttribute('data-animated', true);
      offsets[i] = bound;
  }

  const parallaxAttr = el.getAttribute('data-parallax');
  const elH = el.parentElement.clientHeight;
  const relativity = parallaxAttr === 'relative' ? offsets[i] : ((window.innerHeight - elH) / 2);
  const offsetTop = bound - relativity;
  const coefficent = parallaxAttr !== null && parallaxAttr !== 'relative' ? parallaxAttr : 0.2;
  const maxY = Math.max(-window.innerHeight, offsetTop);
  const baseTransform = Math.floor(Math.min(window.innerHeight, maxY), 2);
  const translateY = baseTransform * parseFloat(coefficent);

  final = lerp(final, translateY, 1);
  gsap.set(el, { y: final });
});

animations.set('title', (el) => {
  const split = new SplitText(el, { type: 'lines', linesClass: 'js-splittedlines' });

  const tl = new gsap.TimelineLite({ onComplete: () => { revertSplit(el, split._originals[0]); } });

  tl
    .set(split.lines, {
      y: 50,
      skewX: -10,
      rotationZ: 5,
      autoAlpha: 0,
    })
    .set(el, { autoAlpha: 1 })
    .staggerTo(split.lines, 1, {
      y: 0,
      skewX: 0,
      rotationZ: 0,
      autoAlpha: 1,
      ease: gsap.Expo.easeOut,
      clearProps: 'all',
    }, 0.1);
});

animations.set('text', (el) => {
  gsap.fromTo(el, 1.5, {
      yPercent: 10,
      skewY: 5,
      autoAlpha: 0,
      transformOrigin: '0 0',
    }, {
      yPercent: 0,
      skewY: 0,
      autoAlpha: 1,
      ease: gsap.Expo.easeOut,
      clearProps: 'all',
    });
});

animations.set('line', (el) => {
  const tl = new gsap.TimelineLite();

  tl
    .fromTo(el, 1.5, {
      scaleX: 0,
      autoAlpha: 0,
      transformOrigin: 0,
    }, {
      scaleX: 1,
      autoAlpha: 1,
      ease: gsap.Expo.easeOut,
      clearProps: 'all',
    }, 0.1, '+=0');
});

animations.set('fade', (el) => {
  gsap.fromTo(el, 1.5, {
      yPercent: 10,
      autoAlpha: 0,
    }, {
      yPercent: 0,
      autoAlpha: 1,
      ease: gsap.Expo.easeOut,
      clearProps: 'all',
    });
});

export default animations;



// WEBPACK FOOTER //
// ./src/scripts/animations.js